(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseEndTimestamp(root) {
    var mode = (root.getAttribute('data-timer-mode') || 'duration').toLowerCase();

    if (mode === 'date') {
      var isoDate = (root.dataset.endDatetime || '').trim();
      if (isoDate) {
        var parsedDate = Date.parse(isoDate);
        if (!isNaN(parsedDate)) return parsedDate;
      }
      return Date.now();
    }

    var dur = parseInt(root.dataset.durationSeconds, 10);
    if (!dur || dur < 60) dur = 7200;
    var key = root.dataset.storageKey;
    if (!key) key = 'swCdEnd_default';
    try {
      var stored = sessionStorage.getItem(key);
      if (stored) {
        var t = parseInt(stored, 10);
        if (!isNaN(t) && t > Date.now()) return t;
      }
      var end = Date.now() + dur * 1000;
      sessionStorage.setItem(key, String(end));
      return end;
    } catch (e) {
      return Date.now() + dur * 1000;
    }
  }

  function bindRoot(root, endTs) {
    var barCompact = root.querySelector('[data-sw-cd-bar]');
    var hEl = root.querySelector('[data-sw-cd-h]');
    var mEl = root.querySelector('[data-sw-cd-m]');
    var sEl = root.querySelector('[data-sw-cd-s]');
    var hideWhenDone = root.getAttribute('data-hide-when-done') === 'true';
    var deadline = typeof endTs === 'number' && !isNaN(endTs) ? endTs : Date.now();

    function tick() {
      var now = Date.now();
      var leftSec = Math.max(0, Math.floor((deadline - now) / 1000));
      var h = Math.floor(leftSec / 3600);
      var m = Math.floor((leftSec % 3600) / 60);
      var s = leftSec % 60;
      var ph = pad(h);
      var pm = pad(m);
      var ps = pad(s);

      if (hEl) hEl.textContent = ph;
      if (mEl) mEl.textContent = pm;
      if (sEl) sEl.textContent = ps;
      if (barCompact) {
        barCompact.textContent = ph + ':' + pm + ':' + ps;
      }

      if (leftSec <= 0) {
        if (hideWhenDone) {
          var wrap = root.closest('.sw-countdown-section');
          if (wrap) wrap.setAttribute('hidden', '');
        }
        return;
      }
      setTimeout(tick, 1000);
    }

    tick();
  }

  function scan() {
    document.querySelectorAll('[data-sw-countdown]:not([data-sw-cd-running])').forEach(function (root) {
      root.setAttribute('data-sw-cd-running', 'true');
      var endTs = parseEndTimestamp(root);
      bindRoot(root, endTs);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
